import { ResourceAction } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

import { PriceListChangeDto } from "../read/detail";
import { priceListChangeDtoSerializer } from "./priceListChangeDtoSerializer";

export const approvedChangesAction = ResourceAction({
  name: "approvedChanges",
  method: "get",
  path: "approvedChanges",
  responseSerializer: MSerializers.result<PriceListChangeDto[], any>(MSerializers.array(priceListChangeDtoSerializer)),
});
